export enum TripAssigneeType {
  TRADESMEN = 'tradesmen',
  VENDOR = 'vendor',
  TEAM_MEMBER = 'team_member',
  REGION_TEAM_MEMBER = 'region_team_member'
}
